if (!customElements.get('ms-product-zoom')) {
  customElements.define('ms-product-zoom', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prepare();
      this.observer = new MutationObserver(() => this.prepare());
      this.observer.observe(this, { childList: true, subtree: true });
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-target], [data-gallery-direction]')) this.reset();
        const button = event.target.closest('.ms-photo-zoom-toggle');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.dragged) { this.dragged = false; return; }
        const expanded = button.getAttribute('aria-pressed') !== 'true';
        this.setZoom(button, expanded);
        if (expanded && event.detail) this.setOrigin(button, event.clientX, event.clientY);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.reset();
      }, options);
      this.addEventListener('slideChanged', () => this.reset(), options);
      this.addEventListener('pointerdown', (event) => {
        const button = event.target.closest('.ms-photo-zoom-toggle');
        if (!button) return;
        this.dragged = false;
        this.start = { x: event.clientX, y: event.clientY };
        if (button.getAttribute('aria-pressed') === 'true' && event.pointerType !== 'mouse') {
          button.setPointerCapture(event.pointerId);
        }
      }, options);
      this.addEventListener('pointermove', (event) => {
        const button = event.target.closest('.ms-photo-zoom-toggle');
        if (!button || button.getAttribute('aria-pressed') !== 'true') return;
        if (event.pointerType !== 'mouse' && event.buttons === 0) return;
        if (event.buttons && this.start && Math.hypot(event.clientX - this.start.x, event.clientY - this.start.y) > 8) this.dragged = true;
        this.setOrigin(button, event.clientX, event.clientY);
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    prepare() {
      this.querySelectorAll('.product__modal-opener--image .product__media').forEach((media) => {
        if (media.querySelector('.ms-photo-zoom-toggle')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ms-photo-zoom-toggle';
        button.setAttribute('aria-label', this.dataset.zoomIn);
        button.setAttribute('aria-pressed', 'false');
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '+';
        button.append(icon);
        media.append(button);
      });
    }

    setZoom(button, expanded) {
      button.setAttribute('aria-pressed', String(expanded));
      button.setAttribute('aria-label', expanded ? this.dataset.zoomOut : this.dataset.zoomIn);
      button.querySelector('span').textContent = expanded ? '−' : '+';
      button.parentElement.style.setProperty('--ms-zoom-scale', expanded ? '2' : '1');
      if (!expanded) {
        button.parentElement.style.removeProperty('--ms-zoom-x');
        button.parentElement.style.removeProperty('--ms-zoom-y');
      }
    }

    setOrigin(button, x, y) {
      const rect = button.getBoundingClientRect();
      const clamp = (value) => Math.max(0, Math.min(100, value));
      button.parentElement.style.setProperty('--ms-zoom-x', `${clamp((x - rect.left) / rect.width * 100)}%`);
      button.parentElement.style.setProperty('--ms-zoom-y', `${clamp((y - rect.top) / rect.height * 100)}%`);
    }

    reset() {
      this.querySelectorAll('.ms-photo-zoom-toggle[aria-pressed="true"]').forEach((button) => this.setZoom(button, false));
    }
  });
}
